import React, { useState } from "react";
import { Grid, Box } from "@mui/material";
import Button from "@mui/material/Button";
import "../../index.css";
import profileData from "../../profileData.js";
import AboutMe from "./AboutMe";
import Skillset from "./Skillset";
import AdditionalSkills from "./AdditionalSkills";
import { motion, AnimatePresence } from "framer-motion";
import "../../App.css";
import "./Profile.css";

const profileNavItems = {
  "About Me": <AboutMe data={profileData["About Me"]} />,
  Skillset: <Skillset data={profileData["Skillset"]} />,
  "Additional Skills": (
    <AdditionalSkills data={profileData["Additional Skills"]} />
  ),
};

const Profile = () => {
  //const profileNavbar = useRef(null);
  //const profileNavbarIsInView = useInView(profileNavbar, { once: true });
  //const profileContent = useRef(null);
  //const profileContentIsInView = useInView(profileContent, { once: true });
  // ${
  // profileNavbarIsInView ? "inview-from-left" : "animate-from-left"
  // }`

  const [activetab, setActivetab] = useState("About Me");
  const tabHandler = (tab) => {
    setActivetab(tab);
  };
  return (
    <Box id="About">
      <Grid container id="Profile-Navbar" className="margin-top">
        <Grid item md={1}></Grid>
        <Grid
          component={motion.div}
          item
          xs={12}
          md={10}
          className={`grid-container grid-item`}
          initial={{ translateX:100, opacity: 0 }}
          whileInView={{ translateX:0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{duration:1}}
        >
          {Object.keys(profileNavItems).map((item) => (
            <Button
              key={item}
              className={activetab === item ? "active-button" : ""}
              onClick={() => {
                tabHandler(item);
              }}
            >
              {item}
            </Button>
          ))}
        </Grid>
        <Grid item md={1}></Grid>
      </Grid>
      <Grid container spacing={2} id="Profile-Container">
        <Grid item xs={1} md={2}></Grid>
        <AnimatePresence mode="wait">
          <Grid
            component={motion.div}
            item
            xs={10}
            md={8}
            key={activetab}
            className={`grid-container grid-item`}
            initial={{ scale: 0, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true }}
            exit={{ scale: 0, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            {profileNavItems[activetab]}
          </Grid>
        </AnimatePresence>
        <Grid item xs={1} md={2}></Grid>
      </Grid>
    </Box>
  );
};

export default Profile;
